/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The mechanic type — discriminates config and state shape
 * @export
 */
export const GamificationType = {
    BINGO: 'BINGO',
    LOCK_IN: 'LOCK_IN',
    PIG_HORSE: 'PIG_HORSE',
    HOT_SEAT: 'HOT_SEAT',
    RIVALRY: 'RIVALRY',
    STREAK_BOARD: 'STREAK_BOARD',
    DAILY_DARE: 'DAILY_DARE',
    QUEST_ROULETTE: 'QUEST_ROULETTE',
    SCAVENGER_HUNT: 'SCAVENGER_HUNT',
    WHEEL_SPIN: 'WHEEL_SPIN',
    TRIVIA: 'TRIVIA',
    PREDICTIONS: 'PREDICTIONS',
    COLLECTION: 'COLLECTION',
    BOUNTY: 'BOUNTY',
    BOSS_BATTLE: 'BOSS_BATTLE',
    SURVIVAL: 'SURVIVAL',
    RELAY: 'RELAY',
    MYSTERY_BOX: 'MYSTERY_BOX',
    FLASH_EVENT: 'FLASH_EVENT',
    BRACKET_VOTE: 'BRACKET_VOTE',
    SABOTEUR: 'SABOTEUR',
    SHOWCASE: 'SHOWCASE',
    CIPHER: 'CIPHER',
    TURF_WAR: 'TURF_WAR',
    MARKET: 'MARKET',
    COUNTDOWN: 'COUNTDOWN'
} as const;
export type GamificationType = typeof GamificationType[keyof typeof GamificationType];


export function instanceOfGamificationType(value: any): boolean {
    for (const key in GamificationType) {
        if (Object.prototype.hasOwnProperty.call(GamificationType, key)) {
            if (GamificationType[key as keyof typeof GamificationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GamificationTypeFromJSON(json: any): GamificationType {
    return GamificationTypeFromJSONTyped(json, false);
}

export function GamificationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationType {
    return json as GamificationType;
}

export function GamificationTypeToJSON(value?: GamificationType | null): any {
    return value as any;
}

export function GamificationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GamificationType {
    return value as GamificationType;
}

